import React, { Fragment, useEffect, useState } from "react";
import {
  Alert,
  Button,
  Col,
  Container,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Modal,
  ModalBody,
  Row,
} from "reactstrap";
import { GetCookieData, GetCookieToken } from "../Cookie/GetCookie";
import axios from "axios";
import { error } from "toastr";
import { useNavigate } from "react-router-dom";
import { CheckPosition } from "../Function/CheckPosition";
import { CheckSubAdmin } from "../Function/CheckSubAdmin";
import Breadcrumb from "../../components/Common/Breadcrumb";

const API_URL = process.env.REACT_APP_API_CORS;

function ViewSlipmoney(props) {
  const {userInfo, windowSize, yearForSlipIncrease} = props
  const [modal, setModal] = useState(false);
  const [pdfLink, setPDFLink] = useState([]);
  const [disButton, setDisButton] = useState(true);
  const [alertMonth, setAlertMonth] = useState(false);
  const [alertYear, setAlertYear] = useState(false);
  const [month, setMonth] = useState(null);
  const [saralyMonthYear, setSalaryMonthYear] = useState([]);
  const [salaryMonth, setSalaryMonth] = useState([]);
  const [year, setYaer] = useState(null);
  const token = GetCookieToken("userToken");
  const userData = GetCookieData("userData");
  const navigate = useNavigate();
  const toggle = () => setModal(!modal);
  const [allYearUser, setAllYearUser] = useState(null)
 
  const months = [
    // { name: "กรุณาเลือก", value: 0 },
    { name: "มกราคม", value: 1 },
    { name: "กุมภาพันธ์", value: 2 },
    { name: "มีนาคม", value: 3 },
    { name: "เมษายน", value: 4 },
    { name: "พฤษภาคม", value: 5 },
    { name: "มิถุนายน", value: 6 },
    { name: "กรกฎาคม", value: 7 },
    { name: "สิงหาคม", value: 8 },
    { name: "กันยายน", value: 9 },
    { name: "ตุลาคม", value: 10 },
    { name: "พฤศจิกายน", value: 11 },
    { name: "ธันวาคม", value: 12 },
  ];

  const fetchUserINFO = async () => {
    const url = `${API_URL}/api/users/info`;
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    await axios
      .get(url, config)
      .then(response => {
        fetchPDFView(response.data.result.user_idcard);
      })
      .catch(error => console.log(error));
  };

  const fetchPDFView = async idCard => {
    const url = `${API_URL}/api/salary/datatable`;
    const params = new URLSearchParams({
      page: 1,
      size: 1000,
      "order[0]": "salary_id",
      "order[1]": "DESC",
      "filter[idcard][0]": idCard,
    });
    const config = {
      headers: { Authorization: `Bearer ${token}` },
      params,
    };
    await axios
      .get(url, config)
      .then(response => {
        const arr = []
        response.data?.result?.map(i => arr.push(i.salary_year))
        const uniqueDataSet = [...new Set(arr)];
        setAllYearUser(uniqueDataSet);
        setSalaryMonth(response.data.result);
      })
      .catch(error => console.log(error));
  };

  const fetchPDFFinancial = async (monthData, yearData) => {
    const url = `${API_URL}/api/report/salary/pdf/${userData.user_id}`;
    const params = new URLSearchParams({
      mode: "path",
      salary_year: Number(yearData),
      salary_month: monthData,
    });
    const config = {
      headers: { Authorization: `Bearer ${token}` },
      params,
    };
    await axios
      .get(url, config)
      .then(response => {
        setPDFLink(response.data.path);
        toggle()
      })
      .catch(error => console.log(error));
  };

  useEffect(() => {
    fetchUserINFO();
  }, []);

  // const fetchSlipFlie = async (monthSlip, yearSlip) =>{
  //   await fetchPDFFinancial(monthSlip, yearSlip);
  // }

  useEffect(() => {
    if (userInfo) {
      if (CheckPosition(userInfo?.position) && CheckPosition(userInfo?.position).includes(1)){
        navigate("/assessment");
      }
    }
  }, [userInfo]);  

  return (
    <Fragment>
        <Row>
          <Col lg={1} className="me-2">
            <Label className="text-nowrap pe-2 mt-2 text-end" style={{fontSize: "16px"}}>ปี :</Label>
          </Col>
          <Col lg={4}>
            <Input id="date-end" type="select" onChange={e => {setYaer(e.target.value); yearForSlipIncrease(e.target.value);}}>
              <option value={0}>กรุณาเลือก</option>
              {allYearUser?.map((year, index) =>
                {
                  return(
                    <option key={index} value={year}>
                        {year}
                      </option>
                  )
                }
              )}
            </Input>
          </Col>
        </Row>
        { year && 
              <Row className="mt-2">
                <Col lg={1} className="me-2">
                  <Label className="text-nowrap pe-2 mt-2 text-end" style={{fontSize: "16px"}}>เดือน :</Label>
                </Col>
                <Col lg={4}>
                  <Input
                    id="moths"
                    type="select"
                    onChange={e => setMonth(e.target.value)}
                  >
                    <option value={0}>กรุณาเลือก</option>
                    {months?.map((month, index) =>
                      {
                        return(
                          <option key={index} value={month.value}>
                              {month.name}
                            </option>
                        )
                      }
                    )}
                  </Input>
                </Col>
                {month &&
                  <Col lg={4} className={windowSize.width < 576 || (windowSize.width >= 576 && windowSize.width < 992 ) ? "mt-2" : ""}>
                        <Button
                          color="success"
                          disabled={year == 0 || month == 0 || salaryMonth.filter(x => x.salary_year == year && x.salary_month == month)?.length == 0}
                          onClick={() => {
                            fetchPDFFinancial(
                                salaryMonth.find(x => x.salary_year == year && x.salary_month == month)?.salary_month, 
                                salaryMonth.find(x => x.salary_year == year && x.salary_month == month)?.salary_year
                            );
                          }}
                        >
                        <i className="fa-regular fa-print me-2"></i>
                          พิมพ์
                        </Button>
                  </Col>
                }
                <Col lg={{offset: 1, size: 5}} 
                  className={windowSize.width < 576 || (windowSize.width >= 576 && windowSize.width < 992 ) ? "mt-2" : ""}>
                  <Alert 
                      color="danger" 
                      className="text-danger mb-0 ms-2" 
                      isOpen={salaryMonth.filter(x => x.salary_year == year && x.salary_month == month)?.length == 0 && month != 0 && month !== null}
                  >
                    ไม่มีข้อมูลของเดือนที่เลือก
                  </Alert>
                </Col>
              </Row>
          }
        

      <Modal className="p-0" size="lg" centered isOpen={modal} toggle={toggle}>
        <ModalBody>
          <div style={{ width: "100%", height: "100vh" }}>
            <iframe
              src={pdfLink}
              title="PDF Viewer"
              width="100%"
              height="100%"
              style={{ border: "none" }}
            ></iframe>
          </div>
        </ModalBody>
      </Modal>
    </Fragment>
  );
}

export default ViewSlipmoney;
